"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import reactUtils from "../../react_utils";
const bem = reactUtils.makeBem("invoice-action-bar");
function handler(f) {
  return (event) => {
    event.stopPropagation();
    event.preventDefault();
    f();
  };
}
function renderActions(props, state) {
  return props.actions.map((action, i) => renderAction(state, action, i));
}
function renderAction(state, action, i) {
  if (state.expanded) {
    return /* @__PURE__ */ React.createElement("div", { key: `action_button_${i}` }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "button--confirmation",
        onClick: handler(action.action)
      },
      action.label
    ));
  } else {
    return /* @__PURE__ */ React.createElement("div", { key: `action_link_${i}` }, /* @__PURE__ */ React.createElement("button", { className: "button", onClick: handler(action.action) }, action.label));
  }
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      expanded: false
    });
    __publicField(this, "expand", (event) => {
      this.setState({ expanded: true });
    });
    __publicField(this, "contract", (event) => {
      this.setState({ expanded: false });
    });
  }
  render() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: bem("__container"),
        onMouseEnter: this.expand,
        onMouseLeave: this.contract
      },
      renderActions(this.props, this.state)
    );
  }
}
